// extracted by mini-css-extract-plugin
export default {"aboutDialogRow":"topbar_aboutDialogRow__QdLgS","aboutDialogContainer":"topbar_aboutDialogContainer__yVdHH"};